export const environment = {
  production: true,
  defaultauth: 'fakebackend',
  firebaseConfig: {
    apiKey: 'AIzaSyCqS9cSPrDCNSQ-Ku2kZf5DBWjPPv7hvcA',
    authDomain: 'test-demo-774f8.firebaseapp.com',
    databaseURL: 'https://test-demo-774f8-default-rtdb.firebaseio.com',
    projectId: 'test-demo-774f8',
    storageBucket: 'test-demo-774f8.appspot.com',
    messagingSenderId: '916438010670',
    appId: '1:916438010670:web:c70cf404da6c0fe7b048bf',
    measurementId: 'G-1N6FB2GG55',
  },
  
  API_URL: 'https://api.aris360.com/api/',
  mainBaseUrl: 'https://api.aris360.com/',
  fileBaseUrl: 'https://aris360storage.blob.core.windows.net/media-files/',
  webUrl: 'https://aris360.com/',
};
